import { render } from "./Recorder.vue?vue&type=template&id=e2df2a90"
import script from "./Recorder.vue?vue&type=script&lang=js"
export * from "./Recorder.vue?vue&type=script&lang=js"

import "./Recorder.vue?vue&type=style&index=0&id=e2df2a90&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__